export const code_data = {
	Created: {
		EN: 'Package awaiting pickup',
		FR: 'Colis en attente de ramassage',
		PT: 'Pacote aguardando coleta',
		DE: 'Paket zur Abholung bereit',
		IT: 'Pacco in attesa di ritiro',
		ES: 'Paquete pendiente de recogi',
		Nil: 'Package awaiting pickup'
	},
	PickedUp_CollectedParcel: {
		EN: 'Goods have been picked up',
		FR: 'Les marchandises ont été récupérées',
		PT: 'Os bens já foram recolhidos',
		DE: 'Die Waren wurden abgeholt',
		IT: 'La merce è già stata ritirata',
		ES: 'Los bienes ya han sido recogidos',
		Nil: 'Goods have been picked up'
	},

	InTransit_Other: {
		EN: 'In the process of cargo transportation',
		FR: 'En cours de transport de marchandises',
		PT: 'Objeto postado',
		DE: 'Im Transport von Gütern',
		IT: 'In corso di trasporto delle merci',
		ES: 'En el transporte de carga',
		Nil: 'Goods have been picked up'
	},

	InTransit_Departure: {
		EN: 'In transit, has left the port of origin',
		FR: `En transit, a quitté le port d'origine`,
		PT: 'Objeto em trânsito',
		DE: 'Im Transport, hat den Versandhafen verlassen',
		IT: 'In transito, ha lasciato il porto di origine',
		ES: 'En tránsito, ya salió del puerto de origen',
		Nil: 'Goods have been picked up'
	},

	InTransit_Arrival: {
		EN: 'In transit, has arrived at the destination port',
		FR: 'En transit, a arrivé au port de destination',
		PT: 'Objeto chegou ao país de destino',
		DE: 'Im Transport, hat den Zielhafen erreicht',
		IT: 'In transito, ha raggiunto il porto di destinazione',
		ES: 'En tránsito, ya llegó al puerto de destino',
		Nil: 'Goods have been picked up'
	},

	InTransit_CustomsProcessing: {
		EN: 'In transit, the goods are undergoing customs clearance',
		FR: 'En transit, les marchandises sont en cours de dédouanement',
		PT: 'Objeto aguardando análise alfandegária',
		DE: 'Im Transport, die Waren befinden sich im Zollabfertigungsprozess',
		IT: 'In transito, la merce è in corso di sdoganamento',
		ES: 'En tránsito, la mercancía está en proceso de despacho en aduana',
		Nil: 'Goods have been picked up'
	},

	InTransit_CustomsReleased: {
		EN: 'In transit, the goods have completed customs clearance',
		FR: 'En transit, les marchandises ont franchi les douanes',
		PT: 'Objeto em transferência: análise alfandegária concluída',
		DE: 'Im Transport, die Waren haben die Zollabfertigung abgeschlossen',
		IT: 'In transito, la merce ha completato lo sdoganamento',
		ES: 'En tránsito, la mercancía ya ha pasado por aduana',
		Nil: 'Goods have been picked up'
	},

	InTransit_CustomsRequiringInformation: {
		EN: 'In transit, the goods require the carrier to provide relevant documents for customs clearance',
		FR: 'En transit, les marchandises nécessitent que le transporteur fournisse les documents nécessaires pour le dédouanement',
		PT: 'Em transporte, a mercadoria requer que o transportador fornece os documentos necessários para a despalfandegamento',
		DE: 'Im Transport, die Waren erfordern vom Frachtführer die Vorlage von relevanten Dokumente für die Zollabfertigung',
		IT: 'In transito, la merce richiede che il trasportatore fornisce i documenti necessari per il sdoganamento',
		ES: 'En tránsito, la mercancía necesita que el transportador proporcione los documentos pertinentes para el despacho en aduana',
		Nil: 'Goods have been picked up'
	},

	InTransit_ForPickUp: {
		EN: 'In transit, arrived and awaiting pickup',
		FR: 'En transit, arrivé et en attente de ramassage',
		PT: 'Objeto em transferência: por favor aguarde',
		DE: 'Im Transport, angekommen und auf Abholung wartet',
		IT: 'In transito, è arrivato e in attesa di ritiro',
		ES: 'En tránsito, ha llegado y está pendiente de recogida',
		Nil: 'Goods have been picked up'
	},

	InTransit_ForDelivery: {
		EN: 'In transit, on the way to delivery',
		FR: 'En transit, en route pour la livraison',
		PT: 'Objeto saiu para entrega ao destinatário',
		DE: 'Im Transport, auf dem Weg zur Zustellung',
		IT: 'In transito, in viaggio per la consegna',
		ES: 'En tránsito, en camino a la entrega',
		Nil: 'Goods have been picked up'
	},

	Delivered_Other: {
		EN: 'Successfully signed for',
		FR: 'Signé avec succès',
		PT: 'Assinado com sucesso',
		DE: 'Erfolgreich abgeschlossen',
		IT: 'Ricevuto con successo',
		ES: 'Firmado correctamente',
		Nil: 'Goods have been picked up'
	},

	Exception_DeliveryExpired: {
		EN: 'Abnormal, excessive shipping time',
		FR: 'Anormal, temps de transport trop long',
		PT: 'Anormal, tempo de transporte excessivo',
		DE: 'Abnorm, zu lange Transportdauer',
		IT: 'Anormale, tempo di trasporto troppo lungo',
		ES: 'Anormal, tiempo de transporte excesivo',
		Nil: 'Goods have been picked up'
	},

	Exception_DeliveryNoBody: {
		EN: 'Delivery failed due to inability to contact recipient during dispatch',
		FR: `Échec de la livraison en raison de l'impossibilité de contacter le destinataire pendant l'expédition`,
		PT: 'Falha na entrega por não conseguir contatar o destinatário durante a entrega',
		DE: 'Lieferung gescheitert, weil Empfänger während des Versand nicht kontaktierbar',
		IT: 'Consegna fallita perché impossibile contattare il destinatario durante la spedizione',
		ES: 'Fracaso en la entrega debido a que no se pudo contactar con el destinatario durante el envío',
		Nil: 'Goods have been picked up'
	},

	Exception_DeliverySecurity: {
		EN: 'Delivery failed due to issues related to package security, customs clearance, and costs during dispatch.',
		FR: `Échec de la livraison en raison de problèmes liés à la sécurité du colis, au dédouanement et aux frais pendant l'expédition.`,
		PT: 'Falha na entrega devido a problemas relacionados à segurança do pacote, ao desembaraço aduaneiro e aos custos durante a entrega.',
		DE: 'Lieferung gescheitert aufgrund von Probleme mit der Paketsicherheit, der Zollabfertigung und Kosten während des Versandprozesses.',
		IT: 'Consegna fallita per problemi riguardanti la sicurezza del pacco, lo sdoganamento e i costi durante la spedizione.',
		ES: 'Fracaso en la entrega debido a problemas relacionados con la seguridad del paquete, el despacho en aduana y los costos durante el envío.',
		Nil: 'Goods have been picked up'
	},

	Exception_DeliveryRejected: {
		EN: 'Abnormality: Delivery failed due to recipient refusing the package.',
		FR: 'Anomalie: Échec de la livraison après le refus du colis par le destinataire.',
		PT: 'Anomalia: Falha na entrega devido à recusa do pacote pelo destinatário.',
		DE: 'Abnorm: Lieferung nicht erfolgreich aufgrund der Zurückweisung des Pakets durch den Empfänger.',
		IT: 'Anomalia: Consegna fallita a causa del rifiuto del pacchetto da parte del destinatario.',
		ES: 'Anomalía: Fallo en la entrega debido a que el destinatario rechazó el paquete.',
		Nil: 'Goods have been picked up'
	},

	Exception_InvalidAddress: {
		EN: 'Abnormality: Delivery failed due to incorrect recipient address.',
		FR: `Anomalie: Échec de la livraison en raison d'une adresse incorrecte du destinataire.`,
		PT: 'Anomalia: Falha na entrega devido ao endereço incorreto do destinatário.',
		DE: 'Abnorm: Lieferung gescheitert aufgrund einer falscher Adresse des Empfängers.',
		IT: 'Anomalia: Consegna fallita a causa di un indirizzo errato del destinatario.',
		ES: 'Anomalía: Fallo en la entrega debido a que la dirección del destinatario es incorrecta.',
		Nil: 'Goods have been picked up'
	},

	Exception_Other: {
		EN: 'Logistics exception',
		FR: 'Exception logistique',
		PT: 'Exceção logística',
		DE: 'Logistikausnahme',
		IT: 'Eccezione logistica',
		ES: 'Excepción logística',
		Nil: 'Goods have been picked up'
	},

	Exception_Returning: {
		EN: 'Abnormality: Package returned and on its way back to the sender.',
		FR: `Anomalie: Colis retourné et en route vers l'expéditeur.`,
		PT: 'Anomalia: Pacote retornado e a caminho de volta para o remetente.',
		DE: 'Abnorm: Paket zurückgesandt und auf dem Weg zurück zum Absender.',
		IT: 'Anomalia: Pacco restituito e in viaggio di ritorno al mittente.',
		ES: 'Anomalía: Paquete devuelto y en camino de regreso al remitente.',
		Nil: 'Goods have been picked up'
	},

	Exception_Returned: {
		EN: 'Abnormality: The sender has signed for the returned package.',
		FR: `Anomalie: L'expéditeur a reçu et signé le colis retourné.`,
		PT: 'Anomalia: O remetente assinou o recebimento do pacote retornado.',
		DE: 'Abnorm: Der Absender hat das zurückgesandte Paket abgeholt und unterschrieben.',
		IT: 'Anomalia: Il mittente ha firmato il ricevimento del pacco restituito.',
		ES: 'Anomalía: El remitente ha recibido y firmado el paquete devuelto.',
		Nil: 'Goods have been picked up'
	},

	Exception_NoBody: {
		EN: 'Abnormality: Unable to contact recipient before delivery.',
		FR: 'Anomalie: Impossible de contacter le destinataire avant la livraison.',
		PT: 'Anomalia: Não foi possível contatar o destinatário antes da entrega.',
		DE: 'Abnorm: Vor der Lieferung konnte der Empfänger nicht kontaktiert werden.',
		IT: 'Anomalia: Impossibile contattare il destinatario prima della consegna.',
		ES: 'Anomalía: No se pudo contactar el destinatario antes de la entrega.',
		Nil: 'Goods have been picked up'
	},

	Exception_Security: {
		EN: 'Abnormality: Delivery failed due to issues related to package security, customs clearance, and fees discovered before dispatch.',
		FR: `Anomalie: Échec de la livraison en raison de problèmes liés à la sécurité du colis, au dédouanement et aux frais découverts avant l'expédition.`,
		PT: 'Anomalia: Falha na entrega devido a problemas relacionados à segurança, desalfandegamento e custos do pacote descobertos antes do envio.',
		DE: 'Abnorm: Lieferung gescheitert aufgrund von Problemen mit der Paketsicherheit, der Zollabfertigung und Gebühren, die vor dem Versand entdeckt wurden.',
		IT: 'Anomalia: Consegna fallita a causa di problemi rilevati prima della spedizione, relativi alla sicurezza, sdoganamento e costi del pacchetto.',
		ES: 'Anomalía: Fallo en la entrega debido a problemas relacionados con la seguridad, despacho y tarifas del paquete descubiertos antes del envío.',
		Nil: 'Goods have been picked up'
	},

	Exception_Damage: {
		EN: 'Abnormality: Damage occurred to the goods during transportation.',
		FR: 'Anomalie: Des dommages ont été constatés sur les marchandises pendant le transport.',
		PT: 'Anomalia: Ocorreu dano aos produtos durante o transporte.',
		DE: 'Abnormität: Während des Transports ist Schaden an der Ware aufgetreten.',
		IT: 'Anomalia: Durante il trasporto, è stato riscontrato un danneggiamento della merce.',
		ES: 'Anomalía: Se ha producido un daño en los bienes durante el transporte.',
		Nil: 'Goods have been picked up'
	},

	Exception_Rejected: {
		EN: 'Abnormality: Received refusal notification before delivery.',
		FR: 'Anomalie: Notification de refus reçue avant la livraison.',
		PT: 'Anomalia: Recebida notificação de recusa antes da entrega.',
		DE: 'Abnormität: Ablehnungsnachricht vor der Lieferung erhalten.',
		IT: 'Anomalia: Ricevuta comunicazione di rifiuto prima della consegna.',
		ES: 'Anomalía: Recibido notificación de rechazo antes de la entrega.',
		Nil: 'Goods have been picked up'
	},
	Exception_Delayed: {
		EN: 'Abnormality: Delay in transportation cycle due to special reasons.',
		FR: 'Anomalie: Retard dans le cycle de transport en raison de raisons spéciales.',
		PT: 'Anomalia: Atraso no ciclo de transporte devido a razões especiais.',
		DE: 'Abnormität: Verzögerung des Transportzyklus aufgrund besonderer Gründe.',
		IT: 'Anomalia: Ritardo nel ciclo di trasporto dovuto a cause speciale.',
		ES: 'Anomalía: Retraso en el ciclo de transporte debido a razones especiales.',
		Nil: 'Goods have been picked up'
	},
	Exception_Lost: {
		EN: 'Abnormality: Loss of goods due to exceptional reasons.',
		FR: 'Anomalie: Perte de marchandises en raison de raisons exceptionnelles.',
		PT: 'Anomalia: Perda de mercadorias devido a razões excepcionais.',
		DE: 'Abnormität: Verlust von Güter aufgrund außergewöhnlicher Gründe.',
		IT: 'Anomalia: Perdita di merci a causa di circostanze eccezionali.',
		ES: 'Anomalía: Pérdida de mercancía debido a razones especiales o excepcionales.',
		Nil: 'Goods have been picked up'
	},
	Exception_Destroyed: {
		EN: 'Abnormality: Due to exceptional reasons, the goods could not be delivered and were destroyed.',
		FR: `Anomalie: En raison de raisons exceptionnelles, les marchandises n'ont pas pu être livrées et ont été détruites.`,
		PT: 'Anomalia: Devido a razões excepcionais, os produtos não puderam ser entregues e foram destruídos.',
		DE: 'Abnormität: Aufgrund außergewöhnlicher Gründe konnten die Güter nicht geliefert werden und wurden zerstört.',
		IT: 'Anomalia: A causa di circostanze eccezionali, la merce non poteva essere consegnata ed è stata distrutta.',
		ES: 'Anomalía: Debido a razones especiales o excepcionales, los productos no pudieron ser entregados y fueron destruídos.',
		Nil: 'Goods have been picked up'
	},
	Exception_Cancel: {
		EN: 'Abnormality: The logistics order has been cancelled due to special reasons.',
		FR: 'Anomalie: La commande logistique a été annulée pour des raisons spéciales.',
		PT: 'Anomalia: O pedido de logística foi cancelado devido a razões especiais.',
		DE: 'Abnormität: Die Logistikauftrag wurde aufgrund besonderer Gründe abgebrochen.',
		IT: `Anomalia: L'ordine di logistica è stato cancellato a causa di motivi speciale.`,
		ES: 'Anomalía: El pedido de logística fue cancelado debido a razones especiales.',
		Nil: 'Goods have been picked up'
	},
	Exception_InvalidCode: {
		EN: 'Cannot be found, package logistics status has not been updated or the order number is incorrect.',
		FR: `Impossible de trouver, le statut de logistique du colis n'a pas été mis à jour ou le numéro de commande est incorrect.`,
		PT: 'Não encontrado, o estado de logística do pacote ainda não foi atualizado ou o número do pedido está incorreto.',
		DE: 'Nicht gefunden, der Logistikstatus des Pakets wurde nicht aktualisiert oder die Auftragsnummer ist falsch.',
		IT: `Non trovato, lo stato della logistica del pacchetto non è stato aggiornato o il numero dell'ordine è errato.`,
		ES: 'No encontrado, el estado de logística del paquete aún no se ha actualizado o el número de pedido es incorrecto.',
		Nil: 'Goods have been picked up'
	},
	InTransit_DeliveryFailure: {
		EN: 'Delivery failed',
		FR: 'Livraison échouée',
		PT: 'Entrega falhou',
		DE: 'Lieferung gescheitert',
		IT: 'Lieferung gescheitert',
		ES: 'Entrega fallida',
		Nil: 'Goods have been picked up'
	}
}

export const dieInfo = {
	EN: [
		{
			title: 'In transit, on the way to delivery',
			description: '2024-05-01 04:24:00',
			operateNode: 'InTransit_ForDelivery'
		},
		{
			title: 'In transit, arrived and awaiting pickup',
			description: '2024-05-01 03:26:06',
			operateNode: 'InTransit_ForPickUp'
		},
		{
			title: 'In transit, the goods have completed customs clearance',
			description: '2024-04-28 12:40:00',
			operateNode: 'InTransit_CustomsReleased'
		},
		{
			title: 'In transit, the goods are undergoing customs clearance',
			description: '2024-04-28 08:49:00',
			operateNode: 'InTransit_CustomsProcessing'
		},
		{
			title: 'In transit, has arrived at the destination port',
			description: '2024-04-27 12:24:45',
			operateNode: 'InTransit_Arrival'
		},
		{
			title: 'In transit, has left the port of origin',
			description: '2024-04-27 08:54:47',
			operateNode: 'InTransit_Departure'
		},
		{
			title: 'In the process of cargo transportation',
			description: '2024-04-27 06:20:50',
			operateNode: 'InTransit_Other'
		},
		{
			title: 'Goods have been picked up',
			description: '2024-04-26 19:18:40',
			operateNode: 'PickedUp_CollectedParcel'
		},
		{
			title: 'Goods awaiting pickup',
			description: '2024-04-26 10:28:50',
			operateNode: 'AwaitingPickup'
		}
	],
	FR: [
		{
			title: 'En transit, en route pour la livraison',
			description: '2024-05-01 04:24:00',
			operateNode: 'InTransit_ForDelivery'
		},
		{
			title: 'En transit, arrivé et en attente de ramassage',
			description: '2024-05-01 03:26:06',
			operateNode: 'InTransit_ForPickUp'
		},
		{
			title: 'En transit, les marchandises ont franchi les douanes',
			description: '2024-04-28 12:40:00',
			operateNode: 'InTransit_CustomsReleased'
		},
		{
			title: 'En transit, les marchandises sont en cours de dédouanement',
			description: '2024-04-28 08:49:00',
			operateNode: 'InTransit_CustomsProcessing'
		},
		{
			title: 'En transit, a arrivé au port de destination',
			description: '2024-04-27 12:24:45',
			operateNode: 'InTransit_Arrival'
		},
		{
			title: `En transit, a quitté le port d'origine`,
			description: '2024-04-27 08:54:47',
			operateNode: 'InTransit_Departure'
		},
		{
			title: 'En cours de transport de marchandises',
			description: '2024-04-27 06:20:50',
			operateNode: 'InTransit_Other'
		},
		{
			title: 'Les marchandises ont été récupérées',
			description: '2024-04-26 19:18:40',
			operateNode: 'PickedUp_CollectedParcel'
		},
		{
			title: 'Marchandises en attente de ramassage',
			description: '2024-04-26 10:28:50',
			operateNode: 'AwaitingPickup'
		}
	],
	PT: [
		{
			title: 'Objeto saiu para entrega ao destinatário',
			description: '2024-05-01 04:24:00',
			operateNode: 'InTransit_ForDelivery'
		},
		{
			title: 'Objeto em transferência: por favor aguarde',
			description: '2024-05-01 03:26:06',
			operateNode: 'InTransit_ForPickUp'
		},
		{
			title: 'Objeto em transferência: análise alfandegária concluída',
			description: '2024-04-28 12:40:00',
			operateNode: 'InTransit_CustomsReleased'
		},
		{
			title: 'Objeto aguardando análise alfandegária',
			description: '2024-04-28 08:49:00',
			operateNode: 'InTransit_CustomsProcessing'
		},
		{
			title: 'Objeto chegou ao país de destino',
			description: '2024-04-27 12:24:45',
			operateNode: 'InTransit_Arrival'
		},
		{
			title: 'Objeto em trânsito',
			description: '2024-04-27 08:54:47',
			operateNode: 'InTransit_Departure'
		},
		{
			title: 'Objeto postado',
			description: '2024-04-27 06:20:50',
			operateNode: 'InTransit_Other'
		},
		{
			title: 'Os bens já foram recolhidos',
			description: '2024-04-26 19:18:40',
			operateNode: 'PickedUp_CollectedParcel'
		},
		{
			title: 'Mercadorias à espera de recolha',
			description: '2024-04-26 10:28:50',
			operateNode: 'AwaitingPickup'
		}
	],
	DE: [
		{
			title: 'Im Transport, auf dem Weg zur Zustellung',
			description: '2024-05-01 04:24:00',
			operateNode: 'InTransit_ForDelivery'
		},
		{
			title: 'Im Transport, angekommen und auf Abholung wartet',
			description: '2024-05-01 03:26:06',
			operateNode: 'InTransit_ForPickUp'
		},
		{
			title: 'Im Transport, die Waren haben die Zollabfertigung abgeschlossen',
			description: '2024-04-28 12:40:00',
			operateNode: 'InTransit_CustomsReleased'
		},
		{
			title: 'Im Transport, die Waren befinden sich im Zollabfertigungsprozess',
			description: '2024-04-28 08:49:00',
			operateNode: 'InTransit_CustomsProcessing'
		},
		{
			title: 'Im Transport, hat den Zielhafen erreicht',
			description: '2024-04-27 12:24:45',
			operateNode: 'InTransit_Arrival'
		},
		{
			title: 'Im Transport, hat den Versandhafen verlassen',
			description: '2024-04-27 08:54:47',
			operateNode: 'InTransit_Departure'
		},
		{
			title: 'Im Transport von Gütern',
			description: '2024-04-27 06:20:50',
			operateNode: 'InTransit_Other'
		},
		{
			title: 'Die Waren wurden abgeholt',
			description: '2024-04-26 19:18:40',
			operateNode: 'PickedUp_CollectedParcel'
		},
		{
			title: 'Waren warten auf Abholung',
			description: '2024-04-26 10:28:50',
			operateNode: 'AwaitingPickup'
		}
	],
	ES: [
		{
			title: 'En tránsito, en camino a la entrega',
			description: '2024-05-01 04:24:00',
			operateNode: 'InTransit_ForDelivery'
		},
		{
			title: 'En tránsito, ha llegado y está pendiente de recogida',
			description: '2024-05-01 03:26:06',
			operateNode: 'InTransit_ForPickUp'
		},
		{
			title: 'En tránsito, la mercancía ya ha pasado por aduana',
			description: '2024-04-28 12:40:00',
			operateNode: 'InTransit_CustomsReleased'
		},
		{
			title: 'En tránsito, la mercancía está en proceso de despacho en aduana',
			description: '2024-04-28 08:49:00',
			operateNode: 'InTransit_CustomsProcessing'
		},
		{
			title: 'En tránsito, ya llegó al puerto de destino',
			description: '2024-04-27 12:24:45',
			operateNode: 'InTransit_Arrival'
		},
		{
			title: 'En tránsito, ya salió del puerto de origen',
			description: '2024-04-27 08:54:47',
			operateNode: 'InTransit_Departure'
		},
		{
			title: 'En el transporte de carga',
			description: '2024-04-27 06:20:50',
			operateNode: 'InTransit_Other'
		},
		{
			title: 'Los bienes ya han sido recogidos',
			description: '2024-04-26 19:18:40',
			operateNode: 'PickedUp_CollectedParcel'
		},
		{
			title: 'Mercancía esperando recogida',
			description: '2024-04-26 10:28:50',
			operateNode: 'AwaitingPickup'
		}
	],
	IT: [
		{
			title: 'In transito, in viaggio per la consegna',
			description: '2024-05-01 04:24:00',
			operateNode: 'InTransit_ForDelivery'
		},
		{
			title: 'In transito, è arrivato e in attesa di ritiro',
			description: '2024-05-01 03:26:06',
			operateNode: 'InTransit_ForPickUp'
		},
		{
			title: 'In transito, la merce ha completato lo sdoganamento',
			description: '2024-04-28 12:40:00',
			operateNode: 'InTransit_CustomsReleased'
		},
		{
			title: 'In transito, la merce è in corso di sdoganamento',
			description: '2024-04-28 08:49:00',
			operateNode: 'InTransit_CustomsProcessing'
		},
		{
			title: 'In transito, ha raggiunto il porto di destinazione',
			description: '2024-04-27 12:24:45',
			operateNode: 'InTransit_Arrival'
		},
		{
			title: 'In transito, ha lasciato il porto di origine',
			description: '2024-04-27 08:54:47',
			operateNode: 'InTransit_Departure'
		},
		{
			title: 'In corso di trasporto delle merci',
			description: '2024-04-27 06:20:50',
			operateNode: 'InTransit_Other'
		},
		{
			title: 'La merce è già stata ritirata',
			description: '2024-04-26 19:18:40',
			operateNode: 'PickedUp_CollectedParcel'
		},
		{
			title: 'Merce in attesa di ritiro',
			description: '2024-04-26 10:28:50',
			operateNode: 'AwaitingPickup'
		}
	],
	Nil: [
		{
			title: 'In transit, on the way to delivery',
			description: '2024-05-01 04:24:00',
			operateNode: 'InTransit_ForDelivery'
		},
		{
			title: 'In transit, arrived and awaiting pickup',
			description: '2024-05-01 03:26:06',
			operateNode: 'InTransit_ForPickUp'
		},
		{
			title: 'In transit, the goods have completed customs clearance',
			description: '2024-04-28 12:40:00',
			operateNode: 'InTransit_CustomsReleased'
		},
		{
			title: 'In transit, the goods are undergoing customs clearance',
			description: '2024-04-28 08:49:00',
			operateNode: 'InTransit_CustomsProcessing'
		},
		{
			title: 'In transit, has arrived at the destination port',
			description: '2024-04-27 12:24:45',
			operateNode: 'InTransit_Arrival'
		},
		{
			title: 'In transit, has left the port of origin',
			description: '2024-04-27 08:54:47',
			operateNode: 'InTransit_Departure'
		},
		{
			title: 'In the process of cargo transportation',
			description: '2024-04-27 06:20:50',
			operateNode: 'InTransit_Other'
		},
		{
			title: 'Goods have been picked up',
			description: '2024-04-26 19:18:40',
			operateNode: 'PickedUp_CollectedParcel'
		},
		{
			title: 'Goods awaiting pickup',
			description: '2024-04-26 10:28:50',
			operateNode: 'AwaitingPickup'
		}
	]
}

export const custom_data = {
	pend: {
		EN: 'Pending',
		FR: 'En attente',
		DE: 'Ausstehend',
		PT: 'Pendente',
		ES: 'Pendiente',
		IT: 'In sospeso',
		Nil: 'Pending'
	},
	await: {
		EN: 'Awaiting Pick up',
		FR: 'En attente de ramassage',
		DE: 'Abholung erwartet',
		PT: 'Aguardando retirada',
		ES: 'Esperando recogida',
		IT: 'In attesa di ritiro',
		Nil: 'Awaiting Pick up'
	},
	pick: {
		EN: 'Picked Up',
		FR: 'Ramassé',
		DE: 'Aufgepickt',
		PT: 'Levantado',
		ES: 'Recogido',
		IT: 'Raccolto',
		Nil: 'Picked Up'
	},
	ship: {
		EN: 'Shipped',
		FR: 'Expédié',
		DE: 'Versandt',
		PT: 'Enviado',
		ES: 'Enviado',
		IT: 'Spedito',
		Nil: 'Shipped'
	},
	deliver: {
		EN: 'Delivered',
		FR: 'Livré',
		DE: 'Ausgeliefert',
		PT: 'Entregue',
		ES: 'Entregado',
		IT: 'Consegnato',
		Nil: 'Delivered'
	}
}

export const shippingInfoText = {
	EN: 'Tracking Number:',
	FR: 'Numéro de suivi:',
	DE: 'Sendungsverfolgungsnummer:',
	PT: 'Número de Rastreamento:',
	ES: 'Número de seguimiento:',
	IT: 'Numero di tracciamento:',
	Nil: 'Tracking Number:'
}

export const getTrackingInfoErr = {
	EN: 'The tracking page is closed, please contact your seller.',
	FR: 'La page de suivi est fermée, veuillez contacter votre vendeur.',
	DE: 'Die Tracking-Seite ist geschlossen, bitte kontaktieren Sie Ihren Verkäufer.',
	PT: 'A página de rastreamento está fechada, por favor, entre em contato com o vendedor.',
	ES: 'La página de seguimiento está cerrada, por favor contacte a su vendedor.',
	IT: 'La pagina di tracciamento è chiusa, si prega di contattare il venditore.',
	Nil: 'The tracking page is closed, please contact your seller.'
}

export const getTrackingInfoErr2 = {
	EN: 'More information will be available soon.',
	FR: `Plus d'informations seront bientôt disponibles.`,
	DE: 'Weitere Informationen werden in Kürze verfügbar sein.',
	PT: 'Mais informações estarão disponíveis em breve.',
	ES: 'Más información estará disponible pronto.',
	IT: 'Ulteriori informazioni saranno presto disponibili.',
	Nil: 'More information will be available soon.'
}
